<template>
  <v-card
    class="d-flex justify-end"
    color="#ffffff"
    height="260"
    width="185"
    flat
    :style="{
      backgroundImage: base64 ? `url(${base64})`: '#ffffff',
      backgroundSize: 'contain'
    }">
    <div class="d-flex ma-1">
      <div class="mr-1">
        <remove-paper
          :item-id="itemId"
          @submitted="$emit('removed')" />
      </div>
      <div class="mr-1">
        <copy-paper
          :item-id="itemId"
          class="ml-1" />
      </div>
      <v-btn
        :to="`/papers/${itemId}`"
        color="primary"
        small
        depressed>
        {{ $t('app.btn.edit') }}
      </v-btn>
    </div>
    <div class="overflow-pixel">
      <div
        :id="`group-canvas-${itemId}`"
        class="relative" />
    </div>
  </v-card>
</template>

<script>
import * as htmlToImage from 'html-to-image'
import { GET_PAPERHTML } from '@/resources/graphql'
import RemovePaper from './RemovePaper.vue'
import CopyPaper from './CopyPaper.vue'

export default {
  components: {
    RemovePaper,
    CopyPaper
  },
  apollo: {
    paperTestHtml: () => ({
      query: GET_PAPERHTML,
      fetchPolicy: 'no-cache',
      skip () {
        return !this.canvas.length
      },
      variables () {
        return {
          canvas: this.canvas,
          paperSize: this.paperSize,
          width: Math.floor(this.width),
          height: Math.floor(this.height)
        }
      },
      result ({ data: { paperTestHtml } }) {
        this.loadPreviewImage(paperTestHtml)
      }
    })
  },
  props: {
    itemId: {
      type: [String, Number],
      required: true
    },
    paperSize: {
      type: [String],
      default: ''
    },
    height: {
      type: [String, Number],
      default: 185
    },
    width: {
      type: [String, Number],
      default: 260
    },
    canvas: {
      type: [Array],
      default: () => ([])
    }
  },
  data () {
    return {
      base64: null
    }
  },
  methods: {
    loadPreviewImage (paperTestHtml) {
      const div = document.createElement('div')
      div.innerHTML = paperTestHtml.trim()
      htmlToImage.toBlob(div, {
        width: this.width,
        height: this.height
      })
      .then((dataUrl) => {
        if (dataUrl) {
          const url = URL.createObjectURL(dataUrl)
          this.base64 = url
        }
      })
      .catch((error) => {
        console.error('oops, something went wrong!', error)
      })
    }
  }
}
</script>
<style scoped>
  .overflow-pixel {
    width: 0;
    height: 0;
    overflow: hidden;
  }
</style>
